export const getSafeDate = (dateStr, fallbackDate) => {
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? fallbackDate : date;
};

export const calculateDateRange = (dateRange) => {
  const now = new Date();
  
  const defaultStart = new Date(now);
  defaultStart.setHours(0, 0, 0, 0);
  const defaultEnd = new Date(now);
  defaultEnd.setHours(23, 59, 59, 999);

  let calculatedStart = getSafeDate(dateRange?.startDate, defaultStart);
  let calculatedEnd = getSafeDate(dateRange?.endDate, defaultEnd);

  if (!dateRange) return { start: calculatedStart, end: calculatedEnd };

  if (dateRange.activeTab === 'customDates' && dateRange.selectedRange && dateRange.selectedRange !== 'customized') {
    const range = dateRange.selectedRange;
    const getIsoDay = (date) => date.getDay() === 0 ? 7 : date.getDay();
    
    switch (range) {
      case 'lastHour':
        calculatedStart = new Date(now.getTime() - 60 * 60 * 1000);
        calculatedEnd = new Date(now);
        break;
      case 'today':
        calculatedStart = new Date(now);
        calculatedStart.setHours(0, 0, 0, 0);
        calculatedEnd = new Date(now);
        calculatedEnd.setHours(23, 59, 59, 999);
        break;
      case 'yesterday':
        calculatedStart = new Date(now);
        calculatedStart.setDate(now.getDate() - 1);
        calculatedStart.setHours(0, 0, 0, 0);
        
        calculatedEnd = new Date(now);
        calculatedEnd.setDate(now.getDate() - 1);
        calculatedEnd.setHours(23, 59, 59, 999);
        break;
      case 'last24Hours':
        calculatedStart = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        calculatedEnd = new Date(now);
        break;
      case 'thisWeek': {
        const currentDay = getIsoDay(now);
        calculatedStart = new Date(now);
        calculatedStart.setDate(now.getDate() - currentDay + 1);
        calculatedStart.setHours(0, 0, 0, 0);
        
        calculatedEnd = new Date(calculatedStart);
        calculatedEnd.setDate(calculatedStart.getDate() + 6);
        calculatedEnd.setHours(23, 59, 59, 999);
        break;
      }
      case 'lastWeek': {
        const currentDay = getIsoDay(now);
        calculatedStart = new Date(now);
        calculatedStart.setDate(now.getDate() - currentDay - 6);
        calculatedStart.setHours(0, 0, 0, 0);
        
        calculatedEnd = new Date(calculatedStart);
        calculatedEnd.setDate(calculatedStart.getDate() + 6);
        calculatedEnd.setHours(23, 59, 59, 999);
        break;
      }
      case 'thisMonth':
        calculatedStart = new Date(now.getFullYear(), now.getMonth(), 1);
        calculatedEnd = new Date(now);
        break;
      case 'lastMonth':
        calculatedStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        calculatedEnd = new Date(now.getFullYear(), now.getMonth(), 0);
        calculatedEnd.setHours(23, 59, 59, 999);
        break;
      case 'last7Days':
        calculatedStart = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        calculatedEnd = new Date(now);
        break;
      case 'last30Days':
        calculatedStart = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        calculatedEnd = new Date(now);
        break;
      default:
        break;
    }
  } else if (dateRange.activeTab === 'customRange') {
    const customLast = Number(dateRange.customLast) || 1;
    calculatedStart = new Date(now);
    
    switch (dateRange.customUnit) {
      case 'minutes':
        calculatedStart = new Date(now.getTime() - customLast * 60 * 1000);
        break;
      case 'hours':
        calculatedStart = new Date(now.getTime() - customLast * 60 * 60 * 1000);
        break;
      case 'days':
        calculatedStart = new Date(now.getTime() - customLast * 24 * 60 * 60 * 1000);
        break;
      case 'months': {
        const expectedMonth = ((calculatedStart.getMonth() - customLast) % 12 + 12) % 12;
        calculatedStart.setMonth(calculatedStart.getMonth() - customLast);
        if (calculatedStart.getMonth() !== expectedMonth) {
          calculatedStart.setDate(0); 
        }
        break;
      }
      default:
        break;
    }
    calculatedEnd = new Date(now);
  }

  return { start: calculatedStart, end: calculatedEnd };
};
